import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { useRegistrationRouteState } from '../features/registration/model';
import { RegistrationPhotoReviewScreen } from '../features/registration/ui';

type PhotoReviewLocationState = {
  selectedPhoto?: File;
};

export function PhotoReviewPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const registrationRoute = useRegistrationRouteState();
  const nextPath = registrationRoute.nextImplementedPath;
  const selectedPhoto =
    (location.state as PhotoReviewLocationState | null)?.selectedPhoto ?? null;

  if (!selectedPhoto) {
    return <Navigate replace to="/registration/photo" />;
  }

  const continueToNextStep = () => {
    if (!nextPath) {
      return;
    }

    navigate(nextPath);
  };

  return (
    <RegistrationPhotoReviewScreen
      initialPhoto={selectedPhoto}
      onContinue={continueToNextStep}
    />
  );
}
